import axios from 'axios';
import { CAMUNDA_URL } from '../constants/camundaConstants';

export default axios.create({
  baseURL: `${CAMUNDA_URL}/rest`
});
